@if (title()) {
  <app-movable-panel-title>
    {{ title() }}
  </app-movable-panel-title>
}
<ng-content></ng-content>
